import React from 'react'
import useClientLocation from '../../../hooks/use-client-location'
import EditModal from '../edit-modal'

const LearningResourceScreen = () => {
    const { goBack, params } = useClientLocation()
    const resourceId = params.resourceId

    return (
        <EditModal
            onHide={() => goBack()}
            resourceId={resourceId !== 'new' ? resourceId : undefined}
        />
    )
}

export default LearningResourceScreen